<template>
  <div class="filter-range-slider">
    <div v-if="histogram" class="filter-range-slider-histogram d-flex align-items-end">
      <div v-for="bucket in histogram"
           :style="{ height: histogramBucketHeight(bucket) }"
           class="bg-light col"
      ></div>
    </div>
    <el-slider
      v-model="sliderInput"
      range
      :min="range.min"
      :max="range.max"
      height="0px"
    >
    </el-slider>
  </div>
</template>

<script>
  import { maxBy } from 'lodash'
  import FilterRange from './filter-range.vue'

  export default {
    name: 'FilterRangeSlider',
    extends: FilterRange,
    props: {
      histogram: {},
    },
    data () {
      return {
        sliderInput: [this.range.min, this.range.max],
      }
    },
    computed: {
      histogramMax () {
        if (this.histogram) {
          const bucket = maxBy(this.histogram, 'doc_count')
          return bucket.doc_count
        }
      },
    },
    methods: {
      histogramBucketHeight (bucket) {
        return bucket.doc_count / this.histogramMax * 100 + '%'
      },
    },
    watch: {
      sliderInput (input) {
        this.input = { min: input[0], max: input[1] }
      },
    },
  }
</script>

<style lang="scss">
  .filter-range-slider-histogram {
    height: 50px;
  }
  .filter-range-slider .el-slider__runway {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-range-slider.vue